import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button, CircularProgress, Alert, Stepper, Step, StepLabel } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadFacturX } from '../services/api';

const SuccessPage = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');
  
  // Étapes du processus
  const steps = ['Upload', 'Vérification des données', 'Génération'];
  const activeStep = 2;

  const handleDownload = async () => {
    setDownloading(true);
    setError('');
    
    try {
      await downloadFacturX(invoiceId);
    } catch (err) {
      setError('Une erreur est survenue lors du téléchargement du fichier Factur-X.');
      console.error(err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Box>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Paper 
        elevation={3} 
        sx={{ 
          maxWidth: 600, 
          mx: 'auto', 
          p: 4,
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <CheckCircleOutlineIcon 
          sx={{ 
            fontSize: 80, 
            color: 'success.main',
            mb: 2 
          }} 
        />
        
        <Typography variant="h4" gutterBottom>
          Factur-X généré avec succès !
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          Votre facture a été convertie au format Factur-X et est prête à être téléchargée.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => navigate('/upload')}
          >
            Convertir une autre facture
          </Button>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            disabled={downloading}
          >
            {downloading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Télécharger le Factur-X'
            )}
          </Button>
        </Box>
      </Paper>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Les fichiers sont conservés pendant 12 heures avant d'être automatiquement supprimés.
        </Typography>
      </Box>
    </Box>
  );
};

export default SuccessPage;
